module.exports = __webpack_public_path__ + "static/media/cover-crop.f0dcdfcf.jpg";